import { render, staticRenderFns } from "./NewPaymentsPayoneerTableMobile.vue?vue&type=template&id=56f93404&scoped=true"
import script from "./NewPaymentsPayoneerTableMobile.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f93404",
  null
  
)

export default component.exports